<template>
  <!--创作规范-->
  <div>
    <div>
      <p
        style="background-color: #ffffff; font-size: 14pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: center"
      >
        <span
          style="
            background-color: #ffffff;

            font-family: 微软雅黑;
            font-size: 14pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >M Art创作规范</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt;
          text-align: justify;
          text-indent: 21pt;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >M Art平台致力于为广大用户提供和谐友善的创作环境，为用户提供良好的阅读体验，共同打造健康有序的内容生态。平台的可持续发展，有赖于各位用户的共同维护与支持。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt;
          text-align: justify;
          text-indent: 21pt;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >真诚建议每位用户在制作和发布作品前仔细阅读本规范。如您发布的内容存在以下问题，将无法通过审核或被系统限制推荐范围，违规情节严重的，将对帐号进行警示乃至封号处理，涉嫌违法犯罪的将被移送行政或司法机关。</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >请各位用户严格遵守平台的内容创作规范，持续创作更多优质内容。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          border-bottom-color: #eaecef;
          border-bottom-style: solid;
          border-bottom-width: 0.75pt;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt;
          padding-bottom: 4pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #ff0000;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >一、M Art平台不允许</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（1）不允许违反法律法规和相关政策</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违反法律法规和相关政策的行为及内容，包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违反宪法确定的基本原则，煽动抗拒或者破坏宪法、法律、行政法规实施；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >危害国家统一、主权和领土完整，泄露国家秘密，危害国家安全，损害国家尊严、荣誉和利益，宣扬恐怖主义、极端主义；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >诋毁民族优秀文化传统，煽动民族仇恨、民族歧视，侵害民族风俗习惯、歪曲民族历史和民族历史人物，损害革命领袖、英雄烈士形象，伤害民族感情，破坏民族团结；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >煽动破坏国家宗教政策，宣扬宗教狂热，危害宗教和睦，伤害信教公民宗教感情，破坏信教公民和不信教公民团结，宣扬邪教、封建迷信；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >危害社会公德，扰乱社会秩序，破坏社会稳定，宣扬淫秽色情、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >教唆、教授、组织他人进行违法乱纪活动，以非法民间组织名义活动的，宣传违法违规物品；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >侵害未成年人合法权益或者损害未成年人身心健康；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >侵犯他人隐私，侮辱或者诽谤他人，侵害他人合法权益；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >含有法律、行政法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（2）不允许抄袭侵权</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >未经授权使用他人享有著作权的内容，包括但不限于以洗稿、复制拼凑等方式重新整合，在表达上与在先作品存在实质性的相同或近似的内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违规使用「原创」功能的：指在平台申请声明「原创」，但内容被证实不符合原创标准要求的。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（3）不允许无资质发布专业领域内容</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >未取得互联网新闻信息服务许可，不得发布新闻信息，新闻信息指：时政类新闻信息，包括有关政治、经济、军事、外交等社会公共事务的报道、评论，以及有关社会突发事件的报道、评论；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >未申请健康类专业资质认证的个人和机构，不得发布疾病治疗、用药指导等健康领域专业性强的内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >未申请财经类专业资质认证的个人和机构，不得发布股票买卖指导、投资指南等财经领域专业性强的内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >我国法律法规要求必须取得特定资质方可从事特定行为的其他情形，依该等法律法规要求处理。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（4）不允许发布谣言或不实内容</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >明显谣言或虚假：与事实相悖或违背科学常理，凭空杜撰、拼凑、编造或曲解事实，制造耸人听闻的谣言，影响较为恶劣；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >疑似谣言：无可信来源，断章取义或以讹传讹，存在诋毁、人身攻击等负面影响的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >信息有误</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >&#xa0;</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >：</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >&#xa0;</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布内容与事实不一致、关键信息不准确，或歪曲事实等行为。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（5）不允许未经M Art同意的商品推广或违规推广</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违规推广包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违禁商品推广：法律规定不准私自制造、买卖、使用、持有、储存、运输、进出口的物品及其他平台禁售商品，如枪支弹药、违禁药品、走私商品等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >有风险商品推广：对人身健康、财产等存在风险的商品，或过分夸大效果、违反基本常识的虚假宣传；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >未知风险商品推广：除上述两种情况外，其他无法明确判断商品用途及功效，但可能存在未知风险的。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（6）不允许流量作弊</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >滥用产品功能进行流量作弊，批量发布重复、无意义的低质内容，恶意刷粉刷赞，影响用户体验、破坏平台规则且损害他人权益的行为。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违规批量发文：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)批量发布重复内容：一段时间内，用非正常手段连续发布大量重复内容，或高度相似内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)批量发无意义/低质内容：连续或大量发布无意义元素，包括但不限于无意义图片、符号、表情、乱码、无序文字等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违规刷粉刷赞：通过非正常手段进行作弊，获取虚假粉丝、虚假点赞数据的行为。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（7）不允许发布引人不适或反感的内容</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >血腥暴力：对真实的人或动物实施暴力，煽动他人施暴；内容中有大量血腥画面，未经过马赛克遮挡，引起用户不适，如尸体、内脏器官等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >密集恐惧：密集排列、分布的事物，造成感官不适；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >猎奇：以猎奇为目的，描述或展现异常事物，引起不适或有不良诱导；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶心：引起强烈刺激的事物，如排泄物，吃活物、体验恶心食物等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恐怖：内容惊悚的事件，或让人产生恐惧心理的生物，具有令人不寒而栗的特征，如人尸、蛇等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >虐待动物：如展示摔打或使用其他工具伤害动物的行为，渲染虐待动物的快感。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（8）不允许宣扬不良价值观</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >挑战公序良俗或游走在社会道德边缘的行为；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >展示违背伦理道德的糜烂生活；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣扬不良生活方式和不良流行文化，渲染消极情绪，宣扬颓废的人生观、世界观和价值观；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣扬拜金主义和享乐主义；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣传和宣扬丧文化、自杀游戏；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >以肯定、赞许的基调或引入模仿的方式表现打架斗殴、羞辱他人、污言秽语；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶意对比、引战行为。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（9）不允许诱导低俗</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >渲染低俗及宣扬低级趣味的行为和内容。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >对性部位和性行为进行展示、过度描述或内涵表述的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >有明显的性挑逗、性骚扰、性侮辱或类似效果的画面、台词、音乐及音效等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >以成人电影、情色电影、三级片、偷拍、走光、露点及各种挑逗性文字或图片作为内容标题、分类或宣传推广；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布和传播其他有伤社会风化的内容。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（10）不允许不文明用语</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >骚扰辱骂：使用污言秽语、蔑称、外号、同音近音词等直接辱骂或言语骚扰他人；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >歧视恶搞：恶搞、歧视特定群体，或言论带有明显的性别歧视、种族歧视、地域歧视等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >情绪宣泄：通过粗俗不堪的口头禅、网络用语等发泄情绪，表达不满的。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（11）不允许恶意营销</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >以恶意营销或诱导消费为目的，内容附带联系方式、售卖链接，或诱导私信联系转线下交易，引导用户消费但可能存在风险的行为。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >联系方式：如电话号码、微信号、公众号、二维码、微信群等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >营销链接：带有明显营销意图的第三方网址，或诱导用户在第三方电商平台领取红包、购买交易的口令和店铺号等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >引导交易；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >票务售卖：明确公示价格，买卖转让演唱会门票等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >虚拟交易：推广虚拟货币、虚拟商品、虚拟服务类交易，如游戏点卡、游戏在线服务、网游装备、QQ号码、Q币、软件序列号、电子书等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >求资源/诱导私信联系：诱导读者通过私信渠道联系或获取资源（如联系方式、链接、加微信群等）；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >纯广告：以推广产品、盈利为目的作品，包括产品宣传、商业服务宣传、商业赞助宣传、商业展销宣传、商家优惠酬宾宣传等。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          border-bottom-color: #eaecef;
          border-bottom-style: solid;
          border-bottom-width: 0.75pt;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt;
          padding-bottom: 4pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #ff0000;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >二、M Art平台不鼓励</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（1）不鼓励标题低质</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >通过夸张描述、隐瞒信息、扭曲原意等方式增加标题吸引力，引诱用户阅读，但与内文真实情况不符，造成用户阅读后心理落差与不良体验。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >标题夸张：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >&#xa0;</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >夸张式标题：将感受、范围、结果、程度等夸张夸大描述，造成耸人听闻的效果；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)悬念式标题：标题滥用转折、隐藏关键性信息，营造悬念、故弄玄虚；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >&#xa0;</span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >强迫式标题：标题采用挑衅恐吓、强迫建议等方式，诱导用户阅读；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >标题与内容原意有偏差：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)标题存在歧义 ：标题对要素信息的表达不清晰、不对称或不完整，形成冲突，对用户产生误导；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)标题无中生有 ：标题捏造内容中不存在的人、物、情节、言论等，或用猜测、不确定消息诱导用户点击；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)标题滥用名称、题材不明确：标题未明确所涉及题材，滥用演员名代替剧中人物名，或用新闻式标题描述影视剧情节，引起歧义，误导用户认为是明星花边或社会时政负面；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(4)封面与标题不符： 封面图与内容主体完全不相关，或封面图结合标题易使读者产生误解；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >标题不规范：标题含有错别字或存在语病、滥用标点符号、语义不通顺等，影响理解与阅读体验。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（2）不鼓励话题无关</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布内容与所带话题的内容不相关，如内容未提及话题主体、内容与话题城市异地、只带话题不写内容等。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（3）不鼓励封面/配图低质</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >封面或配图内容质量差，与文章主体无关且不能为文章增补信息量。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >图片与内容毫无关联，且图片质量差的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >图文明显不相关，带不良图片蹭流量的，图片类型包含但不限于如下：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)有不良诱导倾向的图片；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)偷拍类图片；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)男女亲密同框，易引发低俗、恶俗等不良想象图片等。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（4）不鼓励内容低质</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >图文格式混乱或不美观，音画质量差等影响阅读体验。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >图文低质的内容，包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)排版混乱：文章乱码、无段落或无标点；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)语意不明：病句或错别字较多、乱码符号，有碍于读者理解内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)逻辑混乱：内容拼凑或重复，前后内容没有衔接，无关内容占比较大；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >音画低质的内容，包括但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)视频缩放画面：视频中角标/logo/字幕被剪切，导致显示不全，或画面中人物面部被部分剪切；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)视频添加边框：视频添加边框且占比较大，或水印遮挡画面严重，无法识别视频主体；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)视频添加滤镜：画面带有严重滤镜至色彩失真，或人物明显发白、发红，呈现不正常色调；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(4)视频画面倾斜：画面整体被侧置或倒置，字幕、logo、左右等特征为镜像翻转，或画面被非正常拉长或挤压变形。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #666666;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >（5）不鼓励发布已过时效内容</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >指发布的资讯、消息等是已经过期的内容，并非新近发生的，因时间不明确、隐藏时间词或时间词过期等引起读者理解偏差、混淆了事件的真实发生时间。包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >旧闻新发：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)明确时间陈旧：时间明确且已过时，事件已结束，近期无后续、无持续影响和相关讨论的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)时间不明：文章中提到的事件为很久之前发生的，特意隐去时间，易误导他人是新近发生的事件；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >信息陈旧：指事件持续发酵，已经有新进展、数据有更新、有新的结论，但仍发布陈旧的信息；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >时间词过时：有明确的时间限定词，如「今天」「本月」等，而内容发布时间与限定范围不符，容易引起阅读误解的。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          border-bottom-color: #eaecef;
          border-bottom-style: solid;
          border-bottom-width: 0.75pt;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21pt;
          padding-bottom: 4pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #ff0000;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >三、涉及以下严重违规行为，一经发现，即刻封禁帐号</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（1）违反法律法规和相关政策的行为及内容，包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >违反宪法确定的基本原则的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >危害国家安全，泄露国家秘密，颠覆国家政权、破坏祖国统一、民族团结的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >破坏国家宗教政策，宣扬邪教、封建迷信的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >危害社会公德，扰乱社会秩序，破坏社会稳定，宣扬淫秽色情、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >私自制造、买卖、使用、持有、储存、运输、进出口违规物品，如枪支弹药、管制刀具、毒品、违禁药品、走私商品等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布赌博、传销等违规内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >损害革命领袖、英雄烈士形象；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布法律、法规禁止的其他内容。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（2）发布或诱导色情低俗的内容：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >对性部位和性行为进行展示、过度描述或内涵表述的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >有明显的性挑逗、性骚扰、性侮辱或类似效果的画面、台词、音乐及音效等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >传播色情网站、色情交易或联系方式的。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（3）发布或传播虚假信息并造成恶劣影响的：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >杜撰、编造或曲解事实，制造与事实相悖或违背科学常理的谣言；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >伪造或恶意传播虚假系统信息，包括但不限于系统通知、系统数据；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >杜撰、编造社会负面/敏感事件进行商品分享。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（4）仿冒机构、个人，包括但不限于名人明星、党政机关、新闻机构、公职人员、M Art官方人员、M Art官方活动等，诱骗他人或造成恶劣影响的。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（5）恶意攻击谩骂，使用污言秽语、侮辱性语言或称呼等直接辱骂、骚扰平台或用户。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（6）发布暴力、血腥或其他引人不适的内容：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >自残自杀写实画面、过程实拍，展示暴力实施场景；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >内容中渲染虐待动物的快感，展示伤害动物的行为。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（7）发布或传播损害未成年人身心的行为及内容，包含但不限于以下场景：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >标题或内容含有猥亵未成年，接触未成年性器官，未成年人模拟性行为；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >出现未成年裸露、三点部位衣着不整齐、性器官特写或强调未成年性部位衣着；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >殴打、虐待未成年；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >鼓动未成年人使用或贩卖非法药品、毒品。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（8）无资质发布专业领域内容并造成恶劣影响的：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >无健康领域专业资质发布疾病诊疗、用药指导、针灸拔罐等内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >无财经相关专业资质发布股票买卖指导、投资指南等内容。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（9）发布恶意营销内容，包括但不限于以下形式：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >推广微信或微信公众号时使用变体，如薇欣、伽这个 薇、微^信`公`众`号等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >联合推广，即多个帐号重复多次推荐同一产品或同一联系方式；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)产品：包括但不限于网赚兼职、养生健康、优惠券、交友软件、两性用品、收藏品等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)联系方式：包括但不限于qq号、qq群、微信号、微信公众号等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(3)发布风险医疗内容：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(4)推广非正规医疗场所或医疗服务，包括未知安全性的药品、保健品、医美项目、医疗活动等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(5)宣传违法违规的医疗行为，如非法代孕，胎儿性别鉴定，非法器官移植等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布风险投资内容：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(1)荐股荐彩：推荐购买指定股票、博彩（包含彩票、足彩、六合彩、赌球、跑马）等高风险投资产品，含有联系方式或引导关注第三方帐号的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.25pt;
          text-align: justify;
        "
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >(2)诱导投资：含诱导他人参与投资的各类推广话术，包括但不限于P2P、区块链、各种网赚等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发表贵重收藏品内容中含有联系方式或诱导关注第三方帐号；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣传直销、网赚兼职并鼓吹小成本获大收益，脱离现实（例：住家创业，手机操作即可月入xx万）；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >售卖高仿表、假烟、假冒名牌服饰等；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣传推广封建迷信内容时，如风水转运、画符解咒等，含联系方式或引导关注的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布PUA内容，或情感挽回、婚姻挽回等含有联系方式的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布的视频、音频内容含有语音推广信息；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >宣传刷粉刷量工具、外挂工具、违规查他人隐私信息等违规工具或产品；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >通过美女图片/视频、低俗小说/段子，引导关注第三方帐号的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶意发布社会负面/敏感事件进行商品分享并造成恶劣影响的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶意借国家领导人、公检法军、国家机关、国徽国旗等形象为企业或产品宣传推广。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（10）发布大量低质内容：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布大量内容低质文章，标题、内文夸张耸动；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布大量语句不通、机器编译的内容。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（11）恶意躲避或对抗平台规则，包括但不限于以下行为：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶意批量注册账号，养号囤号，买卖帐号；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >买卖或使用虚假的身份资料、专业资格证明、版权证明、机构资质等证明材料进行帐号注册、认证或开通平台其他功能；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >存在刷粉、刷量、刷赞或其他作弊行为；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >通过非正常手段发布大量内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >发布视频时恶意缩放画面、变速、添加滤镜、变声并影响恶劣的；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >使用转发抽奖功能时，出现违规不兑现奖品或通过抽奖索要钱财等行为。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（12）滥用平台功能进行违规推广：</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >在「自定义菜单」或「扩展链接」中添加违规推广内容；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >使用平台链接类功能进行推广（包括但不限于「自定义菜单」「文章插入外链」「扩展链接」）时，插入直接下载的APK链接；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >恶意篡改自营广告落地页；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >帐号被关闭商品权限后，直接在文中推广商品链接或引导跳转到此前已发布的其他商品文章；</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt 21.3pt;
          text-align: justify;
          text-indent: 0pt;
        "
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">.</span
        ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span
          style="
            background-color: #ffffff;
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >文中引导二次跳转到其他违规推广页面。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            color: #333333;
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: underline;
            text-transform: none;
          "
          >本规范为《用户协议》的组成部分，用户同意《用户协议》，则视为已阅读、理解并同意本规范。</span
        >
      </p>
      <p
        style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; text-align: justify"
      >
        <span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-style: normal;
            text-transform: none;
          "
          >（以下无正文）</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
        <span style="font-family: Calibri; font-size: 10.5pt">&#xa0;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>
